<template>
	<Modal
		:allow-close="false"
		:hide-actions="true"
		:max-width="'max-w-[485px]'"
		rounded-size="rounded-[10px]"
		:prevent-scrolling="false"
		:remove-padding="true"
	>
		<template #body>
			<div class="flex flex-col gap-4 p-6 font-[Inter]">
				<header class="flex flex-col gap-0.5 text-center">
					<h2 class="text-xl leading-7 font-semibold text-gray-900">
						Here's what we recommend for you
					</h2>
					<p class="text-sm leading-5 text-gray-500">
						Job preferences are based on your resume and profile activity. Adjust anything that's off and
						we'll find your best matches.
					</p>
				</header>
				<FirstRunEditQuestions
					:user="user"
					:recommendations="store.recommendations"
					:submit-label="submitLabel"
					@saved="handOffToJobBoard"
				/>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { computed } from 'vue';

import Modal from '../../components/modal.vue';
import FirstRunEditQuestions from '../job-board/first-run-edit-questions.vue';
import { setAuthState } from '../../composables/auth';
import { useExistingUserAutoApplyStore } from '../../store/existing-user-auto-apply.store';

const store = useExistingUserAutoApplyStore();
const { getUser } = setAuthState();

const user = getUser();

// Figma words the CTA differently for users who arrived with a resume already on file.
const submitLabel = computed(() => (store.hadResumeOnFile ? 'Search AutoApply Jobs' : 'Find My Jobs'));

/**
 * A full page load, like the onboarding handoff: the JobBoard reads ?firstRun only when it
 * mounts, so an in-app navigation from the JobBoard itself would never start the first run.
 */
const handOffToJobBoard = () => {
	window.location.href = '/job-board/search?firstRun=1';
};
</script>
